import React from 'react';
import { toast } from 'sonner';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { Tip } from './ui/tip';
import { cn } from '@/lib/utils';

/** Texto del vehículo para pasarle a un proveedor: marca, modelo y año, sin la patente */
export const textoVehiculo = (v: any): string => {
  if (!v) return '';
  const base = [v.make || v.brand, v.model].filter(Boolean).join(' ').trim();
  if (!base) return '';
  return v.year ? `${base} (${v.year})` : base;
};

interface Props {
  vehicle: any | null | undefined;
  className?: string;
  label?: string;
}

/**
 * Botón "copiar" al lado del selector de vehículo: deja en el portapapeles
 * "FORD FOCUS AMBIENTE 5P 1.6L N (2008)" para pegarlo en el WhatsApp del
 * proveedor al pedir precio.
 */
const VehicleCopyButton: React.FC<Props> = ({ vehicle, className, label = 'Copiar marca y modelo para cotizar' }) => {
  const texto = textoVehiculo(vehicle);
  if (!texto) return null;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      toast.success(`Copiado: ${texto}`);
    } catch {
      // Sin acceso al portapapeles moderno (permiso, iframe): copia clásica
      const ta = document.createElement('textarea');
      ta.value = texto;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch { ok = false; }
      document.body.removeChild(ta);
      if (ok) toast.success(`Copiado: ${texto}`);
      else toast.error('No se pudo copiar. Seleccioná el texto a mano.');
    }
  };

  return (
    <Tip label={label}>
      <button
        type="button"
        onClick={copiar}
        aria-label={label}
        className={cn(
          'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-input bg-background text-muted-foreground transition-colors hover:bg-accent hover:text-foreground',
          className
        )}
      >
        <ClipboardDocumentIcon className="h-4 w-4" />
      </button>
    </Tip>
  );
};

export default VehicleCopyButton;
